import PropTypes from 'prop-types';
import { useContext, useRef } from 'react';
import * as yup from 'yup';
import AuthContext from 'context/authContext';
import CrudCard from '../../common/CrudCard/CrudCard';
import {
  useDonationCurrencies,
  useCurrencies,
  useCreateDonationCurrency,
  useUpdateDonationCurrency,
  useDeleteDonationCurrency
} from 'hooks/useDonationSettings';

/* -------------------------------------------------------------------------- */
function ProjectCurrencies({ sectionRef, sideNavLink, subject }) {
  const cardRef = useRef();
  const { organization } = useContext(AuthContext);

  const { donationCurrencies, isLoading: loading } = useDonationCurrencies();
  const { currencies, isLoading: currenciesLoading } = useCurrencies();
  const { createDonationCurrency, isCreating: createLoading } = useCreateDonationCurrency();
  const { updateDonationCurrency, isUpdating: updateLoading } = useUpdateDonationCurrency();
  const { deleteDonationCurrency, isDeleting: deleteLoading } = useDeleteDonationCurrency();

  const currenciesOptions = currencies?.map(({ id, abbreviation, symbol }) => ({
    label: `${abbreviation} (${symbol})`,
    value: id
  }));

  const handleCreate = async ({ currency_id }) => {
    try {
      await createDonationCurrency({
        currency_id,
        organisation_id: organization.id
      });
      cardRef.current.onCreationSuccess();
    } catch (error) {
      console.error(error);
    }
  };

  const handleEdit = async ({ id, data }) => {
    try {
      await updateDonationCurrency({
        id,
        data: {
          currency_id: data.currency_id
        }
      });
      cardRef.current.onEditSuccess();
    } catch (error) {
      console.error(error);
    }
  };

  const handleDelete = async (id) => {
    try {
      await deleteDonationCurrency(id);
      cardRef.current.onDeleteSuccess();
    } catch (error) {
      console.error(error);
    }
  };

  const list = donationCurrencies.map(projectCurrency => ({
    id: projectCurrency.id,
    isOrgLevel: !projectCurrency.branch_id,
    values: [
      {
        value: currenciesOptions?.find(({ value }) => projectCurrency.currency_id === value)?.label,
        name: 'currency_id'
      }
    ]
  }));

  return (
    <CrudCard
      ref={cardRef}
      sectionRef={sectionRef}
      sideNavLink={sideNavLink}
      createData={handleCreate}
      loading={loading}
      editData={handleEdit}
      deleteData={handleDelete}
      createLoading={createLoading}
      updateLoading={updateLoading}
      deleteLoading={deleteLoading}
      formTitle={'Add Project currency'}
      listTitle={'Current Currencies'}
      title={'Project Currencies'}
      inputs={[
        {
          name: 'currency_id',
          placeholder: 'Add Project currency',
          type: 'select',
          required: true,
          value: '',
          validation: yup.string().required('Project currency is required'),
          options: currenciesOptions,
          loading: currenciesLoading
        }
      ]}
      list={list}
      subject={subject}
    />
  );
}

ProjectCurrencies.propTypes = {
  sectionRef: PropTypes.any,
  sideNavLink: PropTypes.any,
  subject: PropTypes.string
};

export default ProjectCurrencies;
